import { Coupon } from '../types/Coupon';

// テンプレート用のクーポンデータ
export const templateCoupons: Coupon[] = [
  {
    id: 'coupon-1',
    code: 'SUMMER2024',
    name: '夏のセール20%オフ',
    description: '全商品対象の夏季キャンペーン。最大20%割引',
    discountType: 'percentage',
    discountValue: 20,
    startDate: new Date('2024-06-01'),
    endDate: new Date('2024-08-31'),
    status: 'active',
    usageLimit: 1000,
    usedCount: 523,
    minPurchaseAmount: 5000,
    createdAt: new Date('2024-05-15'),
    updatedAt: new Date('2024-06-20')
  },
  {
    id: 'coupon-2',
    code: 'WELCOME500',
    name: '新規会員限定500円オフ',
    description: '初回購入時に使える500円割引クーポン',
    discountType: 'fixed-amount',
    discountValue: 500,
    startDate: new Date('2024-01-01'),
    endDate: new Date('2024-12-31'),
    status: 'active',
    usageLimit: 5000,
    usedCount: 1847,
    minPurchaseAmount: 3000,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-06-15')
  },
  {
    id: 'coupon-3',
    code: 'SPRING30',
    name: '春の大感謝祭30%オフ',
    description: '春の特別キャンペーン。対象商品が30%オフ',
    discountType: 'percentage',
    discountValue: 30,
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-05-31'),
    status: 'expired',
    usageLimit: 500,
    usedCount: 489,
    minPurchaseAmount: 10000,
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-06-01')
  },
  {
    id: 'coupon-4',
    code: 'FREESHIP',
    name: '送料無料クーポン',
    description: '配送料が無料になるクーポン',
    discountType: 'fixed-amount',
    discountValue: 600,
    startDate: new Date('2024-01-01'),
    endDate: new Date('2024-12-31'),
    status: 'active',
    usageLimit: 10000,
    usedCount: 3421,
    minPurchaseAmount: 2000,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-06-18')
  },
  {
    id: 'coupon-5',
    code: 'VIP50OFF',
    name: 'VIP会員限定50%オフ',
    description: 'VIP会員専用の特別割引クーポン',
    discountType: 'percentage',
    discountValue: 50,
    startDate: new Date('2024-07-01'),
    endDate: new Date('2024-07-31'),
    status: 'inactive',
    usageLimit: 100,
    usedCount: 0,
    minPurchaseAmount: 20000,
    createdAt: new Date('2024-06-15'),
    updatedAt: new Date('2024-06-15')
  },
  {
    id: 'coupon-6',
    code: 'BIRTHDAY1000',
    name: '誕生日特典1000円オフ',
    description: '誕生月に使える1000円割引クーポン',
    discountType: 'fixed-amount',
    discountValue: 1000,
    startDate: new Date('2024-01-01'),
    endDate: new Date('2024-12-31'),
    status: 'active',
    usageLimit: 2000,
    usedCount: 892,
    minPurchaseAmount: 5000,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-06-10')
  },
  {
    id: 'coupon-7',
    code: 'FLASH15',
    name: 'フラッシュセール15%オフ',
    description: '24時間限定のフラッシュセール',
    discountType: 'percentage',
    discountValue: 15,
    startDate: new Date('2024-06-20'),
    endDate: new Date('2024-06-21'),
    status: 'expired',
    usageLimit: 300,
    usedCount: 287,
    createdAt: new Date('2024-06-19'),
    updatedAt: new Date('2024-06-22')
  },
  {
    id: 'coupon-8',
    code: 'AUTUMN2024',
    name: '秋の大セール25%オフ',
    description: '秋の新作を含む全商品が対象',
    discountType: 'percentage',
    discountValue: 25,
    startDate: new Date('2024-09-01'),
    endDate: new Date('2024-11-30'),
    status: 'draft',
    usageLimit: 1500,
    usedCount: 0,
    minPurchaseAmount: 8000,
    createdAt: new Date('2024-06-15'),
    updatedAt: new Date('2024-06-15')
  },
  {
    id: 'coupon-9',
    code: 'APP2000',
    name: 'アプリダウンロード特典2000円オフ',
    description: 'アプリ初回利用時に使える2000円割引',
    discountType: 'fixed-amount',
    discountValue: 2000,
    startDate: new Date('2024-01-01'),
    endDate: new Date('2024-12-31'),
    status: 'active',
    usageLimit: 3000,
    usedCount: 1256,
    minPurchaseAmount: 10000,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-06-19')
  },
  {
    id: 'coupon-10',
    code: 'REVIEW10',
    name: 'レビュー投稿で10%オフ',
    description: '商品レビュー投稿者限定クーポン',
    discountType: 'percentage',
    discountValue: 10,
    startDate: new Date('2024-01-01'),
    endDate: new Date('2024-12-31'),
    status: 'active',
    usageLimit: 5000,
    usedCount: 2134,
    minPurchaseAmount: 3000,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-06-18')
  }
];

// テンプレートデータをロードする関数
export const loadTemplateData = (): Coupon[] => {
  return templateCoupons;
};
